import React from "react";

function StepIcon({ Icon, title, step, id }) {
  // console.log(id);
  return (
    <div className="bigSpecialStepperButtonContainer">
      <div
        className={`bigSpecialStepperIconContainer ${
          id == step
            ? "bigSpecialStepperActiveIconContainer"
            : id > step
            ? "bigSpecialStepperDisabledIconContainer"
            : ""
        }`}
      >
        <Icon
          fill={id == step ? "#ffffff" : id > step ? "#9ca3af" : "var(--primary)"}
        />
      </div>
      <span
        className={
          id == step
            ? "bigSpecialStepperButtonLabel"
            : id > step
            ? "bigSpecialStepperDisapbledButtonLabel"
            : "bigSpecialStepperInactiveButtonLabel"
        }
      >
        {title}
      </span>
    </div>
  );
}

export default StepIcon;
